import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ProductionCreate = React.lazy(
  () => import('components/Production/Create/Create'),
);

function ScreensProductionCreate() {
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>New Production</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionCreate />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensProductionCreate;
